import { render, staticRenderFns } from "./CalculatorTCI.vue?vue&type=template&id=89e8e028&"
import script from "./CalculatorTCI.vue?vue&type=script&lang=js&"
export * from "./CalculatorTCI.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports